var map = {
	"./air-nga-en/assets/edit-icon.png": 18966,
	"./ais-tai-en/assets/edit-icon.png": 59831,
	"./ais-tai-tha/assets/edit-icon.png": 62627,
	"./demo-arabic/assets/edit-icon.png": 9947,
	"./demo-et-en/assets/edit-icon.png": 49418,
	"./demo-romanian/assets/edit-icon.png": 35172,
	"./demo-um-en/assets/edit-icon.png": 36795,
	"./dtac-tai-en/assets/edit-icon.png": 8388,
	"./dtac-tai-tha/assets/edit-icon.png": 3694,
	"./ethiotel-et-amh/assets/edit-icon.png": 57488,
	"./ethiotel-et-en/assets/edit-icon.png": 78077,
	"./mtn-cg-fr/assets/edit-icon.png": 85400,
	"./mtn-ci-fr/assets/edit-icon.png": 20830,
	"./mtn-cmr-fr/assets/edit-icon.png": 9906,
	"./mtn-gha-en/assets/edit-icon.png": 32837,
	"./mtn-nga-en/assets/edit-icon.png": 34633,
	"./mtn-zam-en/assets/edit-icon.png": 83259,
	"./saf-ke-en/assets/edit-icon.png": 63202,
	"./saudi-uae-en/assets/edit-icon.png": 18699,
	"./tlk-za-en/assets/edit-icon.png": 71574,
	"./vc-za-en/assets/edit-icon.png": 78290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11306;